import React from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative h-screen w-full bg-[#1f2933] overflow-hidden" data-id="element-75">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-76">
        <img src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1920&q=80&auto=format&fit=crop" alt="Tropical beach paradise" className="w-full h-full object-cover" data-id="element-77" />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50 z-10" data-id="element-78"></div>
      </div>

      {/* Content */}
      <div className="relative z-20 h-full flex flex-col justify-center items-center text-center px-4 sm:px-6 lg:px-8" data-id="element-79">
        <span className="text-white/80 text-lg md:text-2xl font-bold tracking-[0.25em] uppercase mb-6 animate-fade-in-up" data-id="element-80">
          Netanel Tours VIP
        </span>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 tracking-tight max-w-5xl mx-auto leading-tight" data-id="element-81">
          Your Personal <br data-id="element-82" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400" data-id="element-83">
            Travel Concierge
          </span>
        </h1>

        <p className="text-xl md:text-2xl text-white/80 mb-12 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-84">
          Customized trips worldwide — exclusive deals — full VIP support
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md mx-auto" data-id="element-85">
          <button onClick={() => scrollToSection('plan-trip')} className="flex-1 bg-white text-[#1f2933] px-8 py-4 rounded font-bold text-lg hover:bg-gray-100 transition-colors flex items-center justify-center" data-id="element-86">
            Plan My Trip <ArrowRight className="ml-2 h-5 w-5" data-id="element-87" />
          </button>
          <button onClick={() => scrollToSection('services')} className="flex-1 border border-white text-white px-8 py-4 rounded font-bold text-lg hover:bg-white/10 transition-colors" data-id="element-88">
            Explore Services
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce" data-id="element-89">
        <ChevronDown className="h-8 w-8 text-white/50" data-id="element-90" />
      </div>
    </section>;
}